/*
 * Scentt brand directory \u2013 live brand search for sections/scentt-brand-directory.liquid.
 * <scentt-brand-directory> containing input[data-scentt-bdir-search], [data-scentt-bdir-group] sections of
 * li[data-scentt-bdir-item data-name], nav links [data-scentt-bdir-jump] and p[data-scentt-bdir-none].
 * Search text never reaches the DOM: it is only compared against the data-name attributes.
 */
(() => {
  const start = () => {
    const S = window.Scentt && Object.isFrozen(window.Scentt) && typeof window.Scentt.html === 'function' ? window.Scentt : null;
    if (!S || customElements.get('scentt-brand-directory')) return;

    const fold = (v) => String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();

    class ScenttBrandDirectory extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-scentt-bdir-search]');
        this.none = this.querySelector('[data-scentt-bdir-none]');
        this.items = Array.from(this.querySelectorAll('[data-scentt-bdir-item]')).map((li) => ({ li, name: fold(li.getAttribute('data-name')) }));
        this.groups = Array.from(this.querySelectorAll('[data-scentt-bdir-group]'));
        this.onInput = S.debounce(() => this.filter(this.input.value), 60);
        this.onKey = (e) => { if (e.key === 'Escape' && this.input.value) { this.input.value = ''; this.filter(''); } };
        this.onJump = this.onJump.bind(this);
        if (this.input) {
          this.input.addEventListener('input', this.onInput);
          this.input.addEventListener('keydown', this.onKey);
          if (this.input.value) this.filter(this.input.value);
        }
        this.addEventListener('click', this.onJump);
      }

      disconnectedCallback() {
        if (this.input) {
          this.input.removeEventListener('input', this.onInput);
          this.input.removeEventListener('keydown', this.onKey);
        }
        this.removeEventListener('click', this.onJump);
      }

      /** Shows brands whose name contains the query (accents and case ignored). Returns the number shown. */
      filter(query) {
        const q = fold(String(query || '').slice(0, 60));
        let total = 0;
        this.items.forEach((it) => { it.show = !q || it.name.includes(q); });
        this.items.forEach((it) => { it.li.hidden = !it.show; if (it.show) total += 1; });
        this.groups.forEach((g) => {
          const shown = g.querySelector('[data-scentt-bdir-item]:not([hidden])');
          g.hidden = !shown;
          const link = this.querySelector(`[data-scentt-bdir-jump="${g.id}"]`);
          if (link) link.classList.toggle('is-off', !shown);
        });
        if (this.none) this.none.hidden = total > 0;
        return total;
      }

      onJump(e) {
        const link = e.target.closest('[data-scentt-bdir-jump]');
        if (!link) return;
        const target = document.getElementById(link.getAttribute('data-scentt-bdir-jump'));
        if (!target || target.hidden) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: S.reducedMotion ? 'auto' : 'smooth', block: 'start' });
        const heading = target.querySelector('h2');
        if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
      }
    }
    customElements.define('scentt-brand-directory', ScenttBrandDirectory);
  };

  if (window.Scentt) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
